import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, Input, OnDestroy, OnInit, SecurityContext } from "@angular/core";
import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";

import { Toolbar,Editor } from "ngx-editor";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: 'webhook-form-richedtext',
    templateUrl: './webhook-form-richedtext.component.html',
    styleUrl: './webhook-form-richedtext.component.scss',
    standalone: false
})

export class WebhookFormRichedTextComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   

    editor: Editor;
    html:string =  '';
    
    toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['code', 'blockquote'],
        ['ordered_list', 'bullet_list'],
        [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
        ['link', 'image'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
    ]
  
    private sanitizer: DomSanitizer = inject(DomSanitizer);

    public sanitizeHtmlContent(htmlstring): SafeHtml {
        return this.sanitizer.sanitize(SecurityContext.HTML, htmlstring);
    }

    
    ngOnInit(): void {
        super.ngOnInit();
        this.editor = new Editor({
            keyboardShortcuts: true,
            attributes: {
                 style: 'height: '+(this.field.minRows*30)+'px;',
            }
        }); 
        

    }

    ngOnDestroy(){
        this.editor.destroy();
    }

}